import { useState, useEffect } from 'react';
import { Route, useHistory } from 'react-router-dom';
import { useAuth } from './auth.context';
import User from '../api/user';

export const ProtectedRoute = (props) => {
  const [shouldRedirect, setShouldRedirect] = useState(false);
  const [redirectPath, setRedirectPath] = useState('');

  let { user } = useAuth();
  const history = useHistory();

  const path = props.path;

  useEffect(() => {
    if (!user) {
      setRedirectPath('/auth/sign-in');
      setShouldRedirect(true);
      return;
    }

    let userJson;
    if (typeof user === 'string') {
      try {
        userJson = JSON.parse(user);
      } catch (error) {
        console.error('Failed to parse user JSON:', error.message);
        userJson = null;
      }
    } else if (typeof user === 'object') {
      userJson = user;
    }

    if (!userJson || !userJson.token || userJson.token === '') {
      console.log('Invalid user or missing token, redirecting to sign-in');
      setRedirectPath('/auth/sign-in');
      setShouldRedirect(true);
      return;
    }

    // Check if the route is in the /auth/ paths, which are always accessible
    if (props.path && props.path.includes('/auth/')) {
      setShouldRedirect(false);
      return;
    }

    // Base paths like '/rtl' are always be allowed - they are just container routes, not actual pages
    if (path === '/rtl') {
      setShouldRedirect(false);
      return;
    }

    // Extract route path for permission check
    const routePath = path.split('/').pop();
    const userInfo = User.GetInfo();

    if (!userInfo) {
      setRedirectPath('/auth/sign-in');
      setShouldRedirect(true);
      return;
    }

    const hasScreens = userInfo && userInfo.screens && Array.isArray(userInfo.screens);

    if (!hasScreens || !userInfo.screens.includes(routePath)) {
      setRedirectPath('/rtl/rtl-default');
      setShouldRedirect(true);
      return;
    }

    setShouldRedirect(false);
  }, [user, path, props.path]);

  useEffect(() => {
    if (shouldRedirect && redirectPath) {
      history.push(redirectPath);
    }
  }, [shouldRedirect, redirectPath, history]);

  if (shouldRedirect) {
    return null;
  }

  return <Route {...props} />;
};
